import {
  demandPartnerServices,
  fetchActiveApps,
  supplyPartnerServices
} from '@shared/api';
import { userTypes } from '@shared/lib/access';
import { store } from '@shared/store';
import {
  setActiveApps,
} from '@shared/store/inventorySlice';
import type { UserType } from '@shared/store/exchangeSlice';
import {
  setDemandPartnerProfiles,
  setSupplyPartnerProfiles
} from '@shared/store/partnerSlice';

const asArray = <T>(value: T[] | null | undefined) => (Array.isArray(value) ? value : []);

export const preloadInventoryState = async (
  userType: UserType | null,
  _orgId: string | null | undefined
) => {
  void _orgId;

  // const shouldFetchDemandPartners =
  //   userType === userTypes.Crackle_User || userType === userTypes.Crackle_Admin;
  // const shouldFetchPublishers =
  //   userType === userTypes.Crackle_User || userType === userTypes.Crackle_Admin;
  const shouldFetchPartnerProfiles =
    userType === userTypes.Crackle_User || userType === userTypes.Crackle_Admin;
  // const isNotCrackleUserorDemandPartner = userType !== userTypes.Crackle_User && userType !== userTypes.Crackle_Admin &&userType !== userTypes.Demand_Partner_Admin && userType !== userTypes.Demand_Partner_User;

  const [
    activeAppsResult,
    // activeDemandPartnersResult,
    // activePublishersResult,
    supplyPartnerProfilesResult,
    demandPartnerProfilesResult
  ] =
    await Promise.allSettled([
      // isNotCrackleUserorDemandPartner? fetchActiveAppsBySpId(orgId || '') : fetchActiveApps(),
      fetchActiveApps(),
      // shouldFetchDemandPartners ? fetchActiveDemandPartners() : Promise.resolve(null),
      // shouldFetchPublishers ? fetchActivePublishers() : Promise.resolve(null),
      shouldFetchPartnerProfiles ? supplyPartnerServices.getAllSPprofileDetails() : Promise.resolve(null),
      shouldFetchPartnerProfiles ? demandPartnerServices.getAllDPprofileDetails() : Promise.resolve(null)
    ]);

  if (activeAppsResult.status === 'fulfilled') {
    const activeApps = asArray(activeAppsResult.value);
    store.dispatch(setActiveApps(activeApps));
  } else {
    console.error('Failed to load active apps', activeAppsResult.reason);
    store.dispatch(setActiveApps([]));
  }

  // if (activeDemandPartnersResult.status === 'fulfilled') {
  //   const activeDemandPartners = asArray(activeDemandPartnersResult.value);
  //   store.dispatch(setActiveDemandPartners(activeDemandPartners));
  // } else {
  //   console.error('Failed to load active demand partners', activeDemandPartnersResult.reason);
  //   store.dispatch(setActiveDemandPartners([]));
  // }

  // if (activePublishersResult.status === 'fulfilled') {
  //   const activePublishers = asArray(activePublishersResult.value);
  //   store.dispatch(setActivePublishers(activePublishers));
  // } else {
  //   console.error('Failed to load active publishers', activePublishersResult.reason);
  //   store.dispatch(setActivePublishers([]));
  // }

  if (supplyPartnerProfilesResult.status === 'fulfilled') {
    const supplyPartnerProfiles = asArray(supplyPartnerProfilesResult.value);
    store.dispatch(setSupplyPartnerProfiles(supplyPartnerProfiles));
  } else {
    console.error('Failed to load supply partner profiles', supplyPartnerProfilesResult.reason);
    store.dispatch(setSupplyPartnerProfiles([]));
  }

  if (demandPartnerProfilesResult.status === 'fulfilled') {
    const demandPartnerProfiles = asArray(demandPartnerProfilesResult.value);
    store.dispatch(setDemandPartnerProfiles(demandPartnerProfiles));
  } else {
    console.error('Failed to load demand partner profiles', demandPartnerProfilesResult.reason);
    store.dispatch(setDemandPartnerProfiles([]));
  }
};
